import React from "react";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import { useFormContext } from "react-hook-form";
import { selectedFreightMode, selectedProvider } from "helpers/freightModeHelper";
import { getLabelWithTranslationFallback } from "helpers/getLabel";

function FreightMode(props: any) {
  const { state } = props;
  const methods = useFormContext();
  const { getValues } = methods;
  const freightMode = selectedFreightMode(state.freightModes.available_modes, getValues("invited_modes"));
  const providers = selectedProvider(state.providers.invited_providers, getValues("invited_providers")?.providers);

  return (
    <div className="font-b3">
      <Row>
        <Col>
          <Row className="mb-2">
            <Col className="text-secondary">
              <FormattedMessage
                id="new-request.quote-confirmation.schedule.acceptQuotationsFor"
                defaultMessage="Accept quotations for"
              />
            </Col>
            <Col>
              {freightMode?.length > 0 &&
                freightMode.map((freight: any) => (
                  <div className="w-100 mb-2" key={Math.random()}>
                    {freight.label}
                  </div>
                ))}
            </Col>
          </Row>
          <hr />
          <Row className="mb-5">
            <Col className="text-secondary">
              <FormattedMessage
                id="new-request.quote-confirmation.schedule.acceptQuotationsFrom"
                defaultMessage="Accept quotations from"
              />
            </Col>
            <Col>
              {providers.length > 0 &&
                providers.map((provider: any) => (
                  <div className="w-100 mb-2" key={Math.random()}>
                    {provider.company_name}
                  </div>
                ))}
            </Col>
          </Row>
          <hr />
          <Row className="mb-2">
            <Col className="text-secondary">
              {getLabelWithTranslationFallback("Quoting deadline", {
                translation: (
                  <FormattedMessage
                    id="new-request.quote-confirmation.schedule.quotingDeadline"
                    defaultMessage="Quoting deadline"
                  />
                ),
              })}
            </Col>
            <Col>
              {moment(getValues("shipment.quoting_deadline_date")).format("DD MMMM YYYY")}{" "}
              {getValues("shipment.quoting_deadline_time")
                ? moment(getValues("shipment.quoting_deadline_time"), "HH:mm:ss").format("HH:mm ")
                : ""}
            </Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">
              {getLabelWithTranslationFallback("Confirmation time", {
                translation: (
                  <FormattedMessage
                    id="new-request.quote-confirmation.schedule.confirmationTime"
                    defaultMessage="Confirmation time"
                  />
                ),
              })}
            </Col>
            <Col>
              {moment(getValues("shipment.confirmation_date")).format("DD MMMM YYYY")}{" "}
              {getValues("shipment.confirmation_time")
                ? moment(getValues("shipment.confirmation_time"), "HH:mm:ss").format("HH:mm ")
                : ""}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default FreightMode;
